import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=1c158760&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=1c158760&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c158760",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c158760')) {
      api.createRecord('1c158760', component.options)
    } else {
      api.reload('1c158760', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=1c158760&scoped=true&", function () {
      api.rerender('1c158760', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2DLXNXOl6XX2u/JS/comp/PopupBox.vue"
export default component.exports